import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {IrbSettingsEvents} from "@irb/irb-settings/irb-settings.events";
import {AppService} from "@irb/app.service";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {Subscription} from "rxjs";
import {IEvent} from "@irb-common/events";
import {ICustomSecurity} from "@irb/irb-editors/irb-editors.model";
import {UtilityService} from "@irb-common/services/utility.service";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({ standalone: false,
  selector: 'irb-tlh-wash-sale-alternatives',
  templateUrl: './tlh-wash-sale-alternatives.component.html',
  styleUrls: ['./tlh-wash-sale-alternatives.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TlhWashSaleAlternativesComponent implements OnInit, OnDestroy {

  private eventSubscription: Subscription;
  private dataSubscription: Subscription;
  isTLHSetInGlobal: any;
  isTlhEnabled: boolean = null;
  securityData: any;
  primaryWS: string;
  secondaryWS: string;
  addNewSecurityItem: any = {
    button: 'Add new security',
    type: 'primarysecurity',
    fromComp: 'TlhWashSaleAlternativesComponent'
  };
  equivalentSecurities: Array<any>;
  selectedPrimarySecurity: IDropdownItem = null;
  equivalentSecuritiesDropdownData: Array<IDropdownItem> = [];
  isSecondaryWSDisabled = true;
  selectedSecondarySecurity: IDropdownItem;
  cashSecId: number;
  isMultipleSecurity = false;
  wslTypeDropdownValues: any = [
    {name: 'None', value: null},
    {name: 'Leave in cash', value: 'cash'},
    {name: 'Buy replacement security', value: 'sec'}
  ];
  primarySecurityIds: Set<number>;
  secondarySecurityIds: Set<number>;
  primaryWSTypeValue:any = {name: 'None', value: null};
  secondaryWSTypeValue:any = {name: 'None', value: null};
  primaryWSTypes: Set<string>;
  @ViewChild('primaryWSFilter') primaryWSFilter: any;
  @ViewChild('secondaryWSFilter') secondaryWSFilter: any;

  @ViewChild("primarySecuritiesDropdownDropdown") primarySecuritiesDropdownDropdown: any;
  @ViewChild("secondarySecuritiesDropdownDropdown") secondarySecuritiesDropdownDropdown: any;

  @Output()
  securityTLHWashSaleEquivalentsChanged = new EventEmitter<any>();

  @Input()
  set securityTLHData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
    this.securityData = JSON.parse(JSON.stringify(value.securityData));
    this.isMultipleSecurity = value.multipleSecurity;
    this.getInitialData();
  }

  learnMoreUrl: SafeUrl;

  constructor( public as: AppService,
               public editorModelService: EditorModelService,
               private utilService: UtilityService,
               private irbEditorsService: IrbEditorsService,
               private cdr: ChangeDetectorRef,
               private sanitizer: DomSanitizer) {

    this.getLearnMoreUrl();
    const globSet: any = this.editorModelService.getGlobalSettings();
    if (globSet)
      this.isTLHSetInGlobal = globSet.isTlhLotLevel || globSet.isTlhPositionLevel;
  }

  ngOnInit(): void {
    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
  }

  getInitialData() {
    this.equivalentSecurities = null;
    this.secondaryWS = null;
    this.primaryWS = null;
    this.secondaryWSTypeValue = {name: 'None', value: null};
    this.primaryWSTypeValue = {name: 'None', value: null};
    this.selectedPrimarySecurity = null;
    this.selectedSecondarySecurity = null;
    this.isSecondaryWSDisabled = true;
    if (!this.isMultipleSecurity) {
      if (this.isTLHSetInGlobal && this.securityData && this.securityData.length > 0) {
        this.isTlhEnabled = this.securityData[0].isTlhEnabled;
      }
      this.dataSubscription = this.irbEditorsService.securitiesForAllEqvSubject.subscribe((securitiesForAllEqvSubject: any) => {
        if (!this.cashSecId) {
          this.irbEditorsService.getSecuritiesSearchDropDown("$CASH").subscribe((cashObj: any) => {
            this.cashSecId = cashObj.items[0].value; // {value: 87318, name: "$CASH"}
            this.loadDD(securitiesForAllEqvSubject);
          });
        } else {
          this.loadDD(securitiesForAllEqvSubject);
        }
      });
    } else {
      const securityIds = this.securityData.map((sec: any) => sec.securityId);
      this.irbEditorsService.getAllSecuritiesForAllEqvs(securityIds).subscribe((res1: any) => {
        const securitiesForAllEqvSubject = res1 && res1.data && res1.data.irebalResponse ? res1.data.irebalResponse : res1;
        this.irbEditorsService.getSecuritiesSearchDropDown("$CASH").subscribe((cashObj: any) => {
          this.cashSecId = cashObj.items[0].value; // {value: 87318, name: "$CASH"}
          this.loadDD(securitiesForAllEqvSubject);
        });
      });
    }
  }

  loadDD(securityEquivalentsResponse: any) {
    this.equivalentSecurities = securityEquivalentsResponse.items as Array<ICustomSecurity>;
    let secName: string;
    if (this.equivalentSecurities && this.equivalentSecurities.length > 0) {
      if (this.dataSubscription) this.dataSubscription.unsubscribe();
      this.equivalentSecuritiesDropdownData = [];
      this.equivalentSecurities.forEach((item: any) => {
        if (item.securityType !== 'OPTION') {
          secName = item.securitySymbol;
          if (item.securityDescription) {
            secName += ' - ' + item.securityDescription;
          }
          this.equivalentSecuritiesDropdownData.push({
            name: secName,
            value: item.securityId
          } as IDropdownItem);
        }
      });

      this.utilService.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");
      if (!this.isMultipleSecurity) {
        this.initializeWSA();
      } else {
        this.initializeMultipleSecWSA();
      }
    }
  }

  initializeWSA() {
    this.primaryWSTypeValue = {name: 'None', value: null};
    const tlhWashSaleAltSecuritiesDTO = this.securityData[0].tlhWashSaleAltSecuritiesDTO || [];
    if (tlhWashSaleAltSecuritiesDTO && tlhWashSaleAltSecuritiesDTO.length) {
      if (tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId) {
        if (tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId === this.cashSecId) {
          this.primaryWS = 'cash';
          this.primaryWSTypeValue = {name: 'Leave in cash', value: 'cash'};
          this.setPrimaryWSA('cash', true);
        } else {
          this.primaryWS = 'sec';
          this.primaryWSTypeValue = {name: 'Buy replacement security', value: 'sec'};
          this.setPrimaryWSA('sec', true);
          this.selectedPrimarySecurity = this.equivalentSecuritiesDropdownData.find(x => x.value === tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId);
          if (this.selectedPrimarySecurity && this.selectedPrimarySecurity.value)
            this.isSecondaryWSDisabled = false;
          if (tlhWashSaleAltSecuritiesDTO.length > 1) {
            if (tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId !== this.cashSecId) {
              this.secondaryWS = 'sec';
              this.secondaryWSTypeValue = {name: 'Buy replacement security', value: 'sec'};
              this.setSecondaryWSA('sec', true);
              this.selectedSecondarySecurity = this.equivalentSecuritiesDropdownData.find(x => x.value === tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId);
            } else {
              this.secondaryWS = 'cash';
              this.secondaryWSTypeValue = {name: 'Leave in cash', value: 'cash'};
              this.setSecondaryWSA('cash', true);
            }
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  initializeMultipleSecWSA() {
    this.primaryWSTypeValue = {name: 'None', value: null};
    this.primaryWSTypes = new Set();
    let secondaryWSTypes: Set<string> = new Set();
    this.primarySecurityIds = new Set();
    this.secondarySecurityIds = new Set();

    this.securityData.forEach((sec: any) => {
      const tlhWashSaleAltSecuritiesDTO = sec.tlhWashSaleAltSecuritiesDTO || [];
      if (tlhWashSaleAltSecuritiesDTO && tlhWashSaleAltSecuritiesDTO.length) {
        if (tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId) {
          if (tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId === this.cashSecId) {
            this.primaryWSTypes.add('cash');
            secondaryWSTypes.add('none');
          } else {
            this.primaryWSTypes.add('sec');
            this.primarySecurityIds.add(tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId);
            if(tlhWashSaleAltSecuritiesDTO.length > 1) {
              if(tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId !== this.cashSecId) {
                secondaryWSTypes.add('sec');
                this.secondarySecurityIds.add(tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId);
              } else if(tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId === this.cashSecId){
                secondaryWSTypes.add('cash');
              }
            } else {
              secondaryWSTypes.add('none');
            }
          }
        }
      } else {
        this.primaryWSTypes.add('none');
        secondaryWSTypes.add('none');
      }
    });

    if (this.primaryWSTypes.size > 1 || (this.primaryWSTypes.has('sec') && this.primarySecurityIds.size > 1)) {
      this.primaryWS = 'various';
      this.primaryWSTypeValue = {name: 'Various', value: 'various'};
      if(this.primaryWSTypes.has('none')) {
        this.isSecondaryWSDisabled = true;
      } else {
        this.isSecondaryWSDisabled = false;
      }
    } else if (this.primaryWSTypes.has('cash')) {
      this.primaryWS = 'cash';
      this.primaryWSTypeValue = {name: 'Leave in cash', value: 'cash'};
      this.setPrimaryWSA('cash', true);
    } else if (this.primaryWSTypes.has('sec') && this.primarySecurityIds.size === 1) {
      this.primaryWS = 'sec';
      this.primaryWSTypeValue = {name: 'Buy replacement security', value: 'sec'};
      this.setPrimaryWSA('sec', true);
      const securityId = Array.from(this.primarySecurityIds)[0];
      this.selectedPrimarySecurity = this.equivalentSecuritiesDropdownData.find(x => x.value === securityId);
      if (this.selectedPrimarySecurity && this.selectedPrimarySecurity.value) {
        this.isSecondaryWSDisabled = false;
      }
    }

    if (secondaryWSTypes.size > 1 || (secondaryWSTypes.has('sec') && this.secondarySecurityIds.size > 1)) {
      this.secondaryWS = 'various';
      this.secondaryWSTypeValue = {name: 'Various', value: 'various'};
      if(this.primaryWSTypes.has('none')) {
        this.isSecondaryWSDisabled = true;
      } else {
        this.isSecondaryWSDisabled = false;
      }
    } else if (secondaryWSTypes.has('cash')) {
      this.secondaryWS = 'cash';
      this.secondaryWSTypeValue = {name: 'Leave in cash', value: 'cash'};
      this.setSecondaryWSA('cash', true);
    } else if (secondaryWSTypes.has('sec') && this.secondarySecurityIds.size === 1) {
      this.secondaryWS = 'sec';
      this.secondaryWSTypeValue = {name: 'Buy replacement security', value: 'sec'};
      this.setSecondaryWSA('sec', true);
      const securityId = Array.from(this.secondarySecurityIds)[0];
      this.selectedSecondarySecurity = this.equivalentSecuritiesDropdownData.find(x => x.value === securityId);
    }

    this.cdr.detectChanges();
  }

  private processEvent(event: IEvent) {
    switch (event.type) {
      case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
        if (event.data) {
          if ((event.data.type === 'primarysecurity' || event.data.type === 'secondarysecurity') && event.data.fromComp === 'TlhWashSaleAlternativesComponent') {
            this.resetSecuritySearch(event.data)
          }
        }
        break;
    }
  }

  isValid() {
    let isValid = true;
    this.cdr.detectChanges();
    if (this.isTlhEnabled && !this.primaryWS) {
      isValid = false;
      if (this.primaryWSFilter && this.primaryWSFilter.input)
        this.primaryWSFilter.input.nativeElement?.classList.add('ng-invalid');
      return isValid;
    }
    if(this.isMultipleSecurity) {
    if (this.primarySecuritiesDropdownDropdown && this.primarySecuritiesDropdownDropdown.input)
      this.primarySecuritiesDropdownDropdown.input.nativeElement?.classList.remove('ng-invalid');
    if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.input)
      this.secondarySecuritiesDropdownDropdown.input.nativeElement?.classList.remove('ng-invalid');
      if(this.primaryWSTypes && this.primaryWSTypes.has('none') && this.isTlhEnabled && this.primaryWSTypeValue.value === 'various') {
        this.primaryWSFilter.input.nativeElement?.classList.add('ng-invalid');
      } else {
        this.primaryWSFilter.input.nativeElement?.classList.remove('ng-invalid');
      }

      if (this.selectedPrimarySecurity && this.secondarySecurityIds && this.secondarySecurityIds.has(this.selectedPrimarySecurity.value)) {
        isValid = false;
        if (this.primarySecuritiesDropdownDropdown && this.primarySecuritiesDropdownDropdown.input) {
          this.primarySecuritiesDropdownDropdown.input.nativeElement.classList.add('ng-invalid');
        }
        this.cdr.detectChanges();
      }

      if(this.selectedSecondarySecurity && this.primarySecurityIds && this.primarySecurityIds.has(this.selectedSecondarySecurity.value)) {
        isValid = false;
        if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.input) {
          this.secondarySecuritiesDropdownDropdown.input.nativeElement.classList.add('ng-invalid');
        }
        this.cdr.detectChanges();
      }
    }
    if (this.primaryWSFilter && this.primaryWSFilter.input && !this.isMultipleSecurity)
      this.primaryWSFilter.input.nativeElement?.classList.remove('ng-invalid');

    if (this.primarySecuritiesDropdownDropdown && this.primarySecuritiesDropdownDropdown.input && !this.isMultipleSecurity)
      this.primarySecuritiesDropdownDropdown.input.nativeElement?.classList.remove('ng-invalid');
    if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.input && !this.isMultipleSecurity)
      this.secondarySecuritiesDropdownDropdown.input.nativeElement?.classList.remove('ng-invalid');

    if (this.primaryWS === 'sec' && !this.selectedPrimarySecurity) {
      isValid = false;
      if (this.primarySecuritiesDropdownDropdown && this.primarySecuritiesDropdownDropdown.input)
        this.primarySecuritiesDropdownDropdown.input.nativeElement.classList.add('ng-invalid');
      this.cdr.detectChanges();
    }
    if (this.secondaryWS === 'sec' && !this.selectedSecondarySecurity) {
      isValid = false;
      if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.input)
        this.secondarySecuritiesDropdownDropdown.input.nativeElement.classList.add('ng-invalid');
      this.cdr.detectChanges();
    }

    if (this.primaryWS === 'sec' && this.secondaryWS === 'sec' && this.selectedPrimarySecurity?.value === this.selectedSecondarySecurity?.value) {
      isValid = false;
      if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.input)
        this.secondarySecuritiesDropdownDropdown.input.nativeElement.classList.add('ng-invalid');
    }
    return isValid;
  }

  openRebalanceGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {defaultTabIndex: 4});
  }

  emitChanges() {
    if(this.isMultipleSecurity) {
      this.setMultipleWashSale();
    } else {
    let passedValue: any = {
      isTlhEnabled: this.isTlhEnabled,
      isValid: this.isValid()
    }
    if (!this.primaryWS) {
      passedValue.tlhWashSaleAltSecuritiesDTO = [];
      this.securityTLHWashSaleEquivalentsChanged.emit(passedValue);
        return;
    }

    let tlhWashSaleSymbol: string = null;
    const tlhWashSaleAltSecuritiesDTO = this.securityData[0].tlhWashSaleAltSecuritiesDTO || [];
    if (tlhWashSaleAltSecuritiesDTO) {
      if (tlhWashSaleAltSecuritiesDTO.length === 0) {
        // no records yet
        let prId = this.selectedPrimarySecurity ? this.selectedPrimarySecurity.value : null;
        if (this.primaryWS === 'cash')
          prId = this.cashSecId;
        tlhWashSaleAltSecuritiesDTO.push({
          tlhWashHarvestSecurityId: this.securityData[0].securityId,
          tlhWashReplaceSecurityId: prId,
          isPrimary: true
        });
        if (this.secondaryWSTypeValue.value) {
          if (this.selectedSecondarySecurity || this.primaryWS === 'sec') {
            let sId = this.selectedSecondarySecurity ? this.selectedSecondarySecurity.value : null;
            if (this.primaryWS === 'sec' && this.secondaryWSTypeValue.value === 'cash')
              sId = this.cashSecId;

            if (sId)
              tlhWashSaleAltSecuritiesDTO.push({
                tlhWashHarvestSecurityId: this.securityData[0].securityId,
                tlhWashReplaceSecurityId: sId,
                isPrimary: false
              });
          }
        }
        passedValue.tlhWashSaleAltSecuritiesDTO = tlhWashSaleAltSecuritiesDTO;
      } else {
        // records exists
        let prId = this.selectedPrimarySecurity ? this.selectedPrimarySecurity.value : null;
        if (this.primaryWS === 'cash') {
          prId = this.cashSecId;
          if (tlhWashSaleAltSecuritiesDTO.length === 2)
            tlhWashSaleAltSecuritiesDTO.splice(1,1);
        }
        tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId = prId;

        if (this.secondaryWSTypeValue.value) {
          if (this.selectedSecondarySecurity || this.primaryWS === 'sec') {
            let sId = this.selectedSecondarySecurity ? this.selectedSecondarySecurity.value : null;
            if (this.primaryWS === 'sec' && this.secondaryWSTypeValue.value === 'cash')
              sId = this.cashSecId;

            if (sId) {
              if (tlhWashSaleAltSecuritiesDTO.length === 1) {
                tlhWashSaleAltSecuritiesDTO.push({
                  tlhWashHarvestSecurityId: this.securityData[0].securityId,
                  tlhWashReplaceSecurityId: sId,
                  isPrimary: false
                });
              } else {
                tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId = sId;
              }
            }
          }
        } else {
          if (tlhWashSaleAltSecuritiesDTO.length === 2)
            tlhWashSaleAltSecuritiesDTO.splice(1,1);
        }
        passedValue.tlhWashSaleAltSecuritiesDTO = tlhWashSaleAltSecuritiesDTO;
      }

      if (this.primaryWS === 'cash')
        tlhWashSaleSymbol = '$CASH';
      else {
        if (this.selectedPrimarySecurity) {
          const secName = this.equivalentSecurities.find(item => item.securityId === this.selectedPrimarySecurity.value);
          tlhWashSaleSymbol = secName.securitySymbol;
        }

        if (tlhWashSaleAltSecuritiesDTO.length === 2) {
          tlhWashSaleSymbol = 'MULTIPLE';
        }
      }
      passedValue.tlhWashSaleSymbol = tlhWashSaleSymbol;
    }

      this.securityTLHWashSaleEquivalentsChanged.emit(passedValue);
    }

  }

    setSecurityTLH(val: boolean) {
      if (this.isTLHSetInGlobal) {
        this.isTlhEnabled = val;
        this.emitChanges();
      }
    }

  setPrimaryWSA(primaryWSAValue: any, initialSet: boolean = false) {
    this.primaryWS = primaryWSAValue;

    if(this.isMultipleSecurity) {
      if (primaryWSAValue === null && this.isTLHSetInGlobal) {
        this.isTlhEnabled = false;
      } else if(primaryWSAValue !== null && this.isTLHSetInGlobal) {
        this.isTlhEnabled = null;
      }

      if(this.primaryWSTypeValue.value === 'sec') {
        this.isSecondaryWSDisabled = false;
        this.selectedPrimarySecurity = null;
      } else {
        this.isSecondaryWSDisabled = true;
        this.secondaryWSTypeValue = {name: 'None', value: null};
        this.secondaryWS = null;
      }
    } else {
      this.primaryWS = primaryWSAValue;
    this.secondaryWS = null;
    this.secondaryWSTypeValue = {name: 'None', value: null};
    this.selectedPrimarySecurity = null;
    this.selectedSecondarySecurity = null;
    this.isSecondaryWSDisabled = true;
    }

    if (!initialSet)
      this.emitChanges();
  }

  setSecondaryWSA(secondaryWSAValue: any, initialSet: boolean = false) {
    this.secondaryWS = secondaryWSAValue;
    if (!this.secondaryWS || this.secondaryWS === 'cash')
      this.selectedSecondarySecurity = null;
    if (!initialSet)
      this.emitChanges();
  }

  setMultipleWashSale() {
    let passedValues: Array<any> = [];
    this.securityData.forEach((sec: any) => {
      let passedValue: any = {
        isTlhEnabled: this.isTlhEnabled,
        isValid: this.isValid()
      }
      if (!this.primaryWS) {
        passedValue.tlhWashSaleAltSecuritiesDTO = [];
        passedValues.push(passedValue);
        this.securityTLHWashSaleEquivalentsChanged.emit(passedValues);
        return;
      }
      let tlhWashSaleSymbol: string = null;
      let tlhWashSaleAltSecuritiesDTO = sec.tlhWashSaleAltSecuritiesDTO || [];
      if (tlhWashSaleAltSecuritiesDTO) {
        if (tlhWashSaleAltSecuritiesDTO.length === 0) {
          // no records yet
          let prId = this.selectedPrimarySecurity ? this.selectedPrimarySecurity.value : null;
          if (this.primaryWS === 'cash')
            prId = this.cashSecId;
          tlhWashSaleAltSecuritiesDTO.push({
            tlhWashHarvestSecurityId: sec.securityId,
            tlhWashReplaceSecurityId: prId,
            isPrimary: true
          });
          if (this.secondaryWSTypeValue.value) {
            if (this.selectedSecondarySecurity || this.primaryWS === 'sec') {
              let sId = this.selectedSecondarySecurity ? this.selectedSecondarySecurity.value : null;
              if (this.primaryWS === 'sec' && this.secondaryWSTypeValue.value === 'cash')
                sId = this.cashSecId;

              if (sId)
                tlhWashSaleAltSecuritiesDTO.push({
                  tlhWashHarvestSecurityId: sec.securityId,
                  tlhWashReplaceSecurityId: sId,
                  isPrimary: false
                });
            }
          }
          passedValue.tlhWashSaleAltSecuritiesDTO = tlhWashSaleAltSecuritiesDTO;
        } else {
          // records exists
          let prId = this.selectedPrimarySecurity ? this.selectedPrimarySecurity.value : null;
          if (this.primaryWS === 'cash') {
            prId = this.cashSecId;
            if (tlhWashSaleAltSecuritiesDTO.length === 2)
              tlhWashSaleAltSecuritiesDTO.splice(1,1);
          }

          if(prId != null && this.primaryWSTypeValue.value !== 'various') {
            tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId = prId;
          }

          if (this.secondaryWSTypeValue.value) {
            if (this.selectedSecondarySecurity || this.primaryWS === 'sec' || this.secondaryWSTypeValue.value === 'cash') {
              let sId = this.selectedSecondarySecurity ? this.selectedSecondarySecurity.value : null;
              if (this.primaryWS === 'sec' && this.secondaryWSTypeValue.value === 'cash') {
                sId = this.cashSecId;
              }

              if (this.secondaryWSTypeValue.value === 'cash')
                sId = this.cashSecId;

              if (sId) {
                if (tlhWashSaleAltSecuritiesDTO.length === 1) {
                  tlhWashSaleAltSecuritiesDTO.push({
                    tlhWashHarvestSecurityId: sec.securityId,
                    tlhWashReplaceSecurityId: sId,
                    isPrimary: false
                  });
                } else {
                  tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId = sId;
                }
              }
            }
          } else {
            if (tlhWashSaleAltSecuritiesDTO.length === 2)
              tlhWashSaleAltSecuritiesDTO.splice(1,1);
          }
          passedValue.tlhWashSaleAltSecuritiesDTO = tlhWashSaleAltSecuritiesDTO;
        }

        if (this.primaryWS === 'cash'|| tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId === this.cashSecId) {
          tlhWashSaleSymbol = '$CASH';
          if(tlhWashSaleAltSecuritiesDTO.length === 2) {
            tlhWashSaleAltSecuritiesDTO.splice(1,1);
          }
        } else {
          if (this.selectedPrimarySecurity) {
            const secName = this.equivalentSecurities.find(item => item.securityId === this.selectedPrimarySecurity.value);
            tlhWashSaleSymbol = secName.securitySymbol;
          }

          if (tlhWashSaleAltSecuritiesDTO.length === 2) {
            tlhWashSaleSymbol = 'MULTIPLE';
          }
        }
        passedValue.tlhWashSaleSymbol = tlhWashSaleSymbol;
      }
      passedValues.push(passedValue);
    });
    this.securityTLHWashSaleEquivalentsChanged.emit(passedValues);
  }


  onClearSelection(type: string) {
    if (type === 'primary') {
      this.onPrimarySecurityChanged(null);
    }
    if (type === 'secondary') {
     this.onSecondarySecurityChanged(null);
    }
  }

  getPrimarySecuritiesDropdown(searchString: any) {
    const d: any = DropdownFilterComponent.getFilteredList(searchString,this.equivalentSecuritiesDropdownData);
    this.primarySecuritiesDropdownDropdown.set(d);
  }

  onPrimarySecurityChanged(selections: IDropdownItem) {
    this.selectedPrimarySecurity = selections;
    if (this.selectedPrimarySecurity && this.selectedPrimarySecurity.value)
      this.isSecondaryWSDisabled = false;

    this.emitChanges();
  }

  onSecondarySecurityChanged(selections: IDropdownItem) {
    this.selectedSecondarySecurity = selections;
    this.emitChanges();
  }

  getSecondarySecuritiesDropdown(searchString: any) {
    const d: any = DropdownFilterComponent.getFilteredList(searchString,this.equivalentSecuritiesDropdownData);
    this.secondarySecuritiesDropdownDropdown.set(d);
  }

  openNewItemSecurityFlow(dataParam: any, secType: string) {
    this.addNewSecurityItem.type = secType;
    dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
    dataParam.editSecurity = true;
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }


  resetSecuritySearch(dataParam: any) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
      if (dataParam.securities && dataParam.securities.responseData) {
        if (dataParam.securities.responseData.length !== 0) {
          this.equivalentSecurities = this.equivalentSecurities.concat(dataParam.securities.responseData);
          let secName = dataParam.securities.responseData[0].securitySymbol
          if (dataParam.securities.responseData[0].securityDescription) {
            secName += ' - ' + dataParam.securities.responseData[0].securityDescription;
          }
          const newItem: any = [{
            value: dataParam.securities.responseData[0].securityId,
            name: secName
          }]
          this.equivalentSecuritiesDropdownData = this.equivalentSecuritiesDropdownData.concat(newItem);
          this.utilService.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");

          if (dataParam.type === 'primarysecurity') {
            //this.selectedPrimarySecurity = newItem[0];
            if (this.primarySecuritiesDropdownDropdown && this.primarySecuritiesDropdownDropdown.setValue) {
              this.primarySecuritiesDropdownDropdown.setValue(newItem[0]);
              this.onPrimarySecurityChanged(newItem[0]);
            }
          }

          if (dataParam.type === 'secondarysecurity') {
            if (this.secondarySecuritiesDropdownDropdown && this.secondarySecuritiesDropdownDropdown.setValue) {
              this.secondarySecuritiesDropdownDropdown.setValue(newItem[0]);
              this.onSecondarySecurityChanged(newItem[0]);
            }
          }

        }
      }

    }
  }

  getPrimaryWSForFilter(searchStr: any) {
    const f = DropdownFilterComponent.getFilteredList(searchStr, this.wslTypeDropdownValues);
    this.primaryWSFilter.set(f);
  }

  getSecondaryWSForFilter(searchStr: any) {
    const f = DropdownFilterComponent.getFilteredList(searchStr, this.wslTypeDropdownValues);
    this.secondaryWSFilter.set(f);
  }

  getLearnMoreUrl() {
    let url = 'https://' + 'sac.schwabinstitutional.com';
    url += '/si2/published/ask/resource/irebal-tlh-full-rebalance';
    this.learnMoreUrl = this.sanitizer.bypassSecurityTrustUrl(url);
  }
  onClickWashSaleHowTo() {
        const passData: any = {
            rebalanceTypeObject: {},
            isTLHSetInGlobal: false
        }
        this.as.fireEvent(IrbSettingsEvents.SHOW_WASH_SALE_INFO, passData);
  }
  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}
